// helper to create the label options for the select box
const createSelectOption = (numberOfBoxes, lensesPerBox, getLabel)=>{
    const label = `${lensesPerBox * numberOfBoxes} ${getLabel('products.unit.contactLenses', {
        defaultValue: 'lenses'
    })}`;
    return `${numberOfBoxes} (${label})`;
};
const createOptionsList = ({ maxSelectableQuantity , lensesPerBox , getLabel  })=>{
    return Array(maxSelectableQuantity).fill(0).reduce((options, _, index)=>{
        const numberOfBoxes = index + 1;
        const name = createSelectOption(numberOfBoxes, lensesPerBox, getLabel);
        options[name] = numberOfBoxes;
        return options;
    }, {});
};
const getCLSelectedQuantityValue = (selectionOptions, selectedQuantity)=>{
    const optionKeys = Object.keys(selectionOptions);
    // If there are no options, then the product is out of stock
    if (!optionKeys.length || !optionKeys[0]) {
        return undefined;
    }
    // Select the first option by default if selectedQuantity is 0
    if (selectedQuantity === 0) {
        return {
            value: optionKeys[0]
        };
    }
    return {
        value: optionKeys[selectedQuantity - 1]
    };
};

export { createOptionsList, getCLSelectedQuantityValue };
//# sourceMappingURL=helpers.js.map
